import React from "react";

const Button = ({
  children,
  onClick,
  variant = "primary",
  disabled = false,
  className = "",
  ...props
}) => {
  const base =
    "px-4 py-2 rounded font-semibold focus:outline-none transition-all duration-200 cursor-pointer";

  const variants = {
    primary: disabled
      ? "bg-gray-400 text-gray-600 cursor-not-allowed opacity-60"
      : "bg-orange-500 text-white hover:bg-orange-600 active:bg-orange-700",
    secondary: disabled
      ? "bg-gray-200 text-gray-400 cursor-not-allowed opacity-60"
      : "bg-gray-200 text-gray-800 hover:bg-gray-300 active:bg-gray-400",
    danger: disabled
      ? "bg-gray-400 text-gray-600 cursor-not-allowed opacity-60"
      : "bg-red-500 text-white hover:bg-red-600 active:bg-red-700",
    success: disabled
      ? "bg-gray-400 text-gray-600 cursor-not-allowed opacity-60"
      : "bg-green-500 text-white hover:bg-green-600 active:bg-green-700",
  };

  return (
    <button
      className={`${base} ${
        variants[variant] || variants.primary
      } ${className}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
